import React, { Component } from 'react'
import { withStyles } from '@material-ui/core'
import Slider from 'react-slick'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import houseIcon from '../images/svg/hut.svg'
import { thumbnailUrl } from '../utils'

const styles = theme => ({
  galleryImg: {
    outline: 'none',
    padding: '0 8px',
    '&::before': {
      content: `''`,
      display: 'block',
      backgroundImage: `url(${houseIcon})`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      height: '150px',
      position: 'absolute',
      top: '2px',
      zIndex: '-1',
      left: 'auto',
      right: 'auto',
      backgroundColor: '#e8f8f7',
    },
    '& img': {
      width: '100%',
      height: '150px',
      maxHeight: '154px',
      minHeight: '154px',
      boxShadow: '0 3px 11px 0 rgba(0, 0, 0, 0.2)',
      objectFit: 'cover',
      cursor: 'pointer',
    },
    '& span': {
      fontSize: '13px',
      letterSpacing: '0.3px',
      color: '#bdbdbd',
      display: 'block',
      marginTop: '7px',
      textAlign: 'left',
    },
  },
  galleryImgOuter: {
    minWidth: '0',
    minHeight: '0',
    width: '95%',
    margin: '25px',
    [theme.breakpoints.down('xs')]: {
      margin: '15px',
    },
    '&:empty': {
      display: 'none',
    },
  },
})

const SLIDER_SETTINGS = {
  dots: true,
  infinite: false,
  speed: 200,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 480, settings: { slidesToShow: 1 } },
    { breakpoint: 768, settings: { slidesToShow: 2 } },
    { breakpoint: 960, settings: { slidesToShow: 3 } },
  ],
}

const LIGHTBOX_SETTINGS = {
  enableZoom: false,
  clickOutsideToClose: false,
  animationOnKeyInput: true,
  animationDuration: 200,
}

class ImageSlider extends Component {
  constructor(props) {
    super(props)

    this.state = {
      photoIndex: 0,
      isOpen: false,
    }
    this.imgLength = props.images.length
    this.dragging = false
  }

  openLightbox = ix => {
    !this.dragging && this.setState({ isOpen: true, photoIndex: ix })
  }

  closeLightbox = () => {
    this.setState({ isOpen: false })
  }

  movePrevOnLightbox = () => {
    const { photoIndex } = this.state
    if (photoIndex === 0) {
      return false
    }
    this.setState({
      photoIndex: (photoIndex + this.imgLength - 1) % this.imgLength,
    })
  }

  moveNextOnLightbox = () => {
    const { photoIndex } = this.state
    if (photoIndex === this.imgLength - 1) {
      return false
    }
    this.setState({ photoIndex: (photoIndex + 1) % this.imgLength })
  }

  componentDidMount() {
    document.addEventListener('keydown', this.sliderKeyNavigation)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.sliderKeyNavigation)
  }

  sliderKeyNavigation = event => {
    switch (event.keyCode) {
      case 27:
        this.closeLightbox()
        break
      case 37:
        this.movePrevOnLightbox()
        break
      case 39:
        this.moveNextOnLightbox()
        break
      default:
        break
    }
  }

  render() {
    const { classes, images } = this.props
    const { photoIndex, isOpen } = this.state
    const prevIndex = (photoIndex + this.imgLength - 1) % this.imgLength
    const nextIndex = (photoIndex + 1) % this.imgLength

    return (
      <div className={classes.galleryImgOuter}>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            prevSrc={photoIndex === 0 ? null : images[prevIndex]}
            nextSrc={photoIndex === this.imgLength - 1 ? null : images[nextIndex]}
            onCloseRequest={this.closeLightbox}
            onMovePrevRequest={this.movePrevOnLightbox}
            onMoveNextRequest={this.moveNextOnLightbox}
            {...LIGHTBOX_SETTINGS}
          />
        )}

        {this.imgLength > 0 && (
          <Slider
            beforeChange={() => {
              this.dragging = true
            }}
            afterChange={() => {
              this.dragging = false
            }}
            {...SLIDER_SETTINGS}>
            {images.map((image, ix) => (
              <div key={`img_${ix}`} className={classes.galleryImg}>
                <img
                  onClick={() => {
                    this.openLightbox(ix)
                  }}
                  src={thumbnailUrl(image)}
                  alt=""
                />
              </div>
            ))}
          </Slider>
        )}
      </div>
    )
  }
}

export default withStyles(styles)(ImageSlider)



// WEBPACK FOOTER //
// ./src/components/ImageSlider.js